export const getPortalTarget = (id: string | null): HTMLElement => {
  const targetElement = id ? document.getElementById(id) : null;
  return targetElement || document.body;
};
